import { CheckCircleFilled } from '@ant-design/icons';
import { REVIEW_STATUS } from 'utils/constants';
import styles from 'styles/components/reviewStatusIcon.module.scss';

const ReviewStatusIcon = ({ status }) => (
  <div>
    {status === REVIEW_STATUS.TO_DO ? (
      <div className={styles.reviewTodoIcon} />
    ) : status === REVIEW_STATUS.IN_PROGRESS ? (
      <div className={styles.reviewTodoIcon}>-</div>
    ) : (
      <CheckCircleFilled style={{ color: '#59c959', fontSize: 20 }} />
    )}
  </div>
);

export default ReviewStatusIcon;
